/**
 * Freemium Conversion Funnel — thin client for /api/freemium/*.
 * Reuses the existing authenticatedFetch helper from ../api instead of
 * duplicating auth-header/token logic.
 */
import { authenticatedFetch } from '../api';

const API_BASE = process.env.REACT_APP_API_BASE || "https://mockbot-api1.onrender.com";

export async function getFreemiumStatus() {
  const res = await authenticatedFetch(`${API_BASE}/api/freemium/status`);
  if (!res.ok) throw new Error(`Freemium status request failed: ${res.status}`);
  return res.json();
}

export async function getReportPreview(sessionId) {
  const res = await authenticatedFetch(`${API_BASE}/api/freemium/report-preview/${sessionId}`);
  if (!res.ok) throw new Error(`Report preview request failed: ${res.status}`);
  return res.json();
}
